import styled, { css } from 'styled-components'

export const CircleActionButtonContainer = styled.div<{ disabled?: boolean, bg?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  button {
    width: 32px;
    height: 32px;
    background: ${props => props.bg ?? '#fff'};
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 50%;

    svg {
      width: 60%;
      height: 60%;
      color: #E1712A;
    }
  }

  button:disabled {
    cursor: not-allowed;
  }

  span {
    color: #65666A;
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    margin-top: 4px;
  }

  &:hover {
    button {
      background: #F3C6AA;
    }

    span {
      color: #E1712A;
    }
  }

  ${props => props.disabled && css`
    opacity: 0.6;
    cursor: not-allowed;
    
    button {
      background: #F3C6AA;
    }

    span {
      color: #E1712A;
    }
  `}
`